// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1byii","savePackageButton":"ClientWallet_savePackageButton__36xjp"};